import { useSelector } from "react-redux";
import { getDailyItinerary, selectDailyItinerary, selectLoadingDailyItinerary } from "./DailyItinerarySlice";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { useEffect } from "react";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGenderless } from "@fortawesome/pro-solid-svg-icons";
import { DailyItineraryItemModel, DailyItineraryTypes } from "services/api/cplapi/CPLAPI";
import { Link } from "react-router-dom";

const DailyItinerary: React.FC = () => {
  const thunkDispatch = useThunkDispatch();
  const loadingDailyItinerary = useSelector(selectLoadingDailyItinerary);
  const dailyItinerary = useSelector(selectDailyItinerary);

  useEffect(() => {
    thunkDispatch(getDailyItinerary());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getItineraryColour(itemType: DailyItineraryTypes) {
    switch (itemType) {
      case DailyItineraryTypes.Event:
        return "text-warning";
      case DailyItineraryTypes.Task:
        return "text-success";
      case DailyItineraryTypes.Meeting:
        return "text-primary";
      default:
        return "";
    }
  }

  function getItineraryLink(item: DailyItineraryItemModel) {
    switch (item.type) {
      case DailyItineraryTypes.Event:
        return <div className="fw-normal timeline-content text-muted ps-3">{item.title}</div>;
      case DailyItineraryTypes.Meeting:
        return (
          <Link
            data-test-id={`daily-itinerary-card__view-meeting-link-${item.recordID}`}
            className="fw-normal timeline-content text-muted ps-3"
            to={`/Meeting/${item.recordID}/Details`}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="View meeting"
          >
            {item.title}
          </Link>
        );
      case DailyItineraryTypes.Task:
        return (
          <Link
            data-test-id={`daily-itinerary-card__view-task-link-${item.recordID}`}
            className="fw-normal timeline-content text-muted ps-3"
            to={`/UserTask/${item.recordID}/Details`}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="View Task"
          >
            {item.title}
          </Link>
        );
    }
  }
  return (
    <div className="card dashboard-card">
      <div className="card-header">
        <div className="card-title">Daily Itinerary</div>
      </div>
      <div className="card-body dashboard-card-body">
        <ActivityIndicator isBusy={loadingDailyItinerary} busyMessage="Getting Daily Itinerary">
          {dailyItinerary.length > 0 ? (
            <div className="timeline-label">
              {dailyItinerary.map((item, index) => {
                return (
                  <div key={index} className="timeline-item">
                    <div className="timeline-label">{item.time}</div>
                    <div className="timeline-badge">
                      <FontAwesomeIcon className={getItineraryColour(item.type!)} icon={faGenderless} />
                    </div>
                    {getItineraryLink(item)}
                  </div>
                );
              })}
            </div>
          ) : (
            <>{!loadingDailyItinerary && <>Looks like your day is free</>}</>
          )}
        </ActivityIndicator>
      </div>
    </div>
  );
};

export default DailyItinerary;
